const powerpointTemplate = {
  en: {
    powerpointTemplate: {
      upload: {
        modal: {
          help_modal: {
            title: "PowerPoint Template Help",
            file_upload_overview: "File Upload Process Overview",
            uploading_files: "Uploading Files",
            upload_instruction: "Users need to upload both a PowerPoint (.pptx) and Excel (.xlsx) file. The Excel file will contain data, and the PowerPoint will have placeholders for that data to be injected.",
            placeholder_syntax: "Placeholder Syntax",
            basic_placeholder_syntax: "Basic Placeholder Syntax: [[SheetName!CellRef]]",
            placeholder_description: "Placeholders in the PowerPoint slides follow the format [[SheetName!CellRef]], where SheetName is the Excel sheet's name, and CellRef is the Excel cell reference.",
            placeholder_example: "e.g., [[Sheet1!B3]] replaces the placeholder with the value from cell B3 on Sheet1.",
            markers_syntax: "Using Markers (pptstart, pptend)",
            markers_description: "In the Excel sheet, special markers like pptstart and pptend define the ranges of data to be injected into the PowerPoint's embedded Excel sheets.",
            markers_placement: "It is important that the pptstart marker is placed in cell A1 of the embedded Excel sheet to ensure that the data mapping works correctly.",
            markers_example: "e.g., pptstart:SalesData starts the data for a specific section, and pptend:SalesData marks the end of that section."
          }
        }
      },
      title: "PowerPoint Template",
      form: {
        success_download: "Your file has been processed and downloaded automatically.",
        processing_status: "Processing Status",
        manual_vba_required: "Manual VBA Code Required:",
        manual_vba_required_part2: "Some charts require manual refresh. Please run this VBA code in PowerPoint after downloading:",
        manual_vba_required_part3: "Click the code above to select all, then copy and paste into PowerPoint's VBA editor.",
        skipMacro: "I will run the macro refreshing chart cache myself (faster)",
        formatMillionDisabled: "Disable million formatting (1000000 instead of 1.0M)",
        macro_for_all_charts: "I want to use the macro even for charts that could be done without.",
        selectOnePptx: "Select one pptx",
        selectOneXlsx: "Select one xlsx",
        send: "Send"
      }
    }
  }
}

module.exports.powerpointTemplate = powerpointTemplate;
